import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { reportError } from 'observability/reportError'

const reportCacheError = (error: unknown, key: unknown) =>
	reportError(error, { source: 'react-query', operation: String(key ?? 'unknown') })

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => reportCacheError(error, query.queryKey[0])
	}),
	mutationCache: new MutationCache({
		onError: (error, _variables, _context, mutation) =>
			reportCacheError(error, mutation.options.mutationKey?.[0])
	})
})
